import MapViewV2 from "./MapView";

export default function MapTab({}) {

    return (
        <MapViewV2 type={'base'} />
    )
}